"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EConsortiumLender = void 0;
exports.EConsortiumLender = {
    CFCAL: "CFCAL",
    CACF: "CACF",
};
